import _ from 'lodash'

import {
  ADD_ANNOUNCEMENT_FIELD_ERROR,
  ADD_ANNOUNCEMENT_FIELDS_ERRORS,
  CHANGE_ANNOUNCEMENT_FIELD,
  CLEAR_ANNOUNCEMENT_FIELD_ERROR,
  PREDEFINE_ANNOUNCEMENT_FORM_DATA,
  RESET_ANNOUNCEMENT_FORM_DATA,
} from './actions'

export interface AnnouncementFormData {
  title: string
  content: string
  thumbnail_url: string
}

export const defaultFormData = (
  predefined: Partial<AnnouncementFormData> = {},
): AnnouncementFormData =>
  _.merge(
    {
      title: '',
      content: '',
      thumbnail_url: '',
    },
    predefined,
  )

export interface AnnouncementFormState {
  formData: AnnouncementFormData
  errors: Record<string, string | undefined>
}

export const initialState = (): AnnouncementFormState => ({
  formData: defaultFormData(),
  errors: {},
})

type Action =
  | ReturnType<typeof import('./actions').changeAnnouncementFormField>
  | ReturnType<typeof import('./actions').addFieldError>
  | ReturnType<typeof import('./actions').addFieldsErrors>
  | ReturnType<typeof import('./actions').clearFieldError>
  | ReturnType<typeof import('./actions').predefineAnnouncementForm>
  | ReturnType<typeof import('./actions').resetAnnouncementForm>

export default function root(
  state: AnnouncementFormState = initialState(),
  action: Action,
): AnnouncementFormState {
  switch (action.type) {
    case CHANGE_ANNOUNCEMENT_FIELD:
      return {
        ...state,
        formData: {
          ...state.formData,
          [action.payload.key]: action.payload.value,
        },
      }

    case ADD_ANNOUNCEMENT_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: action.payload.error,
        },
      }

    case ADD_ANNOUNCEMENT_FIELDS_ERRORS:
      return {
        ...state,
        errors: action.payload.errors,
      }

    case CLEAR_ANNOUNCEMENT_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: undefined,
        },
      }

    case PREDEFINE_ANNOUNCEMENT_FORM_DATA:
      return {
        ...state,
        formData: defaultFormData(action.payload),
        errors: {},
      }

    case RESET_ANNOUNCEMENT_FORM_DATA:
      return {
        ...state,
        formData: defaultFormData(),
        errors: {},
      }

    default:
      return state
  }
}
